import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import CatalogObjectSerializer from '@square/dashboard-items-data/serializers/connect/catalog-object';
export default CatalogObjectSerializer.extend(EmbeddedRecordsMixin, {
  attrs: {
    values: {
      embedded: 'always',
      serializedOnFragment: 'item_option_data'
    }
  },
  serialize(snapshot) {
    const json = this._super(snapshot, {
      includeId: true
    });
    json.item_option_data.values.forEach(value => value.item_option_value_data.item_option_id = json.id);
    return json;
  }
});